import request from '@/utils/request'

export interface AdminHelpContact {
  customerServiceUrl: string
  customerServiceCorpId: string
  canManage: boolean
  configurationError?: string
  consultationIdentity?: string
}

export const readAdminHelpContact = () => request({ url: 'system/adminHelpCustomerService', method: 'GET', preserveErrorDetails: true })
export const readAdminHelpContactPermission = () => request({ url: 'system/adminHelpCustomerService/permission', method: 'GET', preserveErrorDetails: true })
export const saveAdminHelpContact = (data: Pick<AdminHelpContact, 'customerServiceUrl' | 'customerServiceCorpId'>) =>
  request({ url: 'system/adminHelpCustomerService', method: 'POST', data, preserveErrorDetails: true })
